export default __webpack_public_path__ + "static/media/prof.3d9bcdf5.png";